// ─── Aperçu carte (lecture) ───────────────────────────────────────
// Carte OSM d'un point : WebView interactive sur mobile (module d'Expo Go),
// image statique key-free en repli (web / module absent) → tap = itinéraire.
//
// Si les coordonnées manquent mais qu'on a une adresse, on la GÉOCODE : la
// plupart des lieux saisis à la main n'ont pas de lat/lng, et la fiche restait
// muette alors que l'adresse suffisait à situer le point.
import React, { useEffect, useState } from 'react';
import { View, Image, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { demanderItineraire, lienCarteEmbed, lienCarteStatique } from './itineraire';
import { geocoderAdresse } from './rechercheLieu';

export default function CarteApercu({ coords, adresse, hauteur = 150 }) {
  const UI = useUI();
  const fournies = coords && coords.lat != null && coords.lng != null ? coords : null;
  const [resolues, setResolues] = useState(null);

  useEffect(() => {
    if (fournies || !String(adresse || '').trim()) { setResolues(null); return undefined; }
    let vivant = true;
    geocoderAdresse(adresse).then(c => { if (vivant) setResolues(c); }).catch(() => {});
    return () => { vivant = false; };
  }, [fournies?.lat, fournies?.lng, adresse]);   // eslint-disable-line react-hooks/exhaustive-deps

  const point = fournies || resolues;
  if (!point) return null;

  const s = makeStyles(UI, hauteur);
  const embed = lienCarteEmbed(point);
  let WV = null;
  if (Platform.OS !== 'web' && embed) { try { WV = require('react-native-webview').WebView; } catch { WV = null; } }
  if (WV) return <View style={s.wrap}><WV source={{ uri: embed }} style={s.img} /></View>;
  const img = lienCarteStatique(point);
  if (!img) return null;
  const go = () => demanderItineraire({ ...point, adresse });
  return (
    <TouchableOpacity style={s.wrap} activeOpacity={0.85} onPress={go}>
      <Image source={{ uri: img }} style={s.img} resizeMode="cover" />
    </TouchableOpacity>
  );
}

const makeStyles = (UI, h) => StyleSheet.create({
  wrap: { marginTop: 10, borderRadius: 12, overflow: 'hidden', borderWidth: 0.5, borderColor: UI.border },
  img: { width: '100%', height: h, backgroundColor: UI.card },
});
